import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=2ce812e8&scoped=true&"
import script from "./Disclaimer.vue?vue&type=script&lang=js&"
export * from "./Disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./Disclaimer.vue?vue&type=style&index=0&id=2ce812e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce812e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce812e8')) {
      api.createRecord('2ce812e8', component.options)
    } else {
      api.reload('2ce812e8', component.options)
    }
    module.hot.accept("./Disclaimer.vue?vue&type=template&id=2ce812e8&scoped=true&", function () {
      api.rerender('2ce812e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/doc/Disclaimer.vue"
export default component.exports